import React, { Component, PropTypes } from 'react';
import t from 'tcomb-form';

const ProfitType = t.enums({
  nonprofit: "Non Profit",
  forprofit: "For Profit"
});

const IsWomenExclusive = t.enums({
  yes: "Yes",
  no: "No"
});

const AdminAccount = t.struct({
  contactHead: t.maybe(t.String),
  contact_first_name: t.maybe(t.String),
  contact_last_name: t.maybe(t.String),
  contact_email: t.maybe(t.String),
  contact_phone: t.maybe(t.String),
  contact_intl_phone: t.maybe(t.String),
  more: t.maybe(t.String),
  profit_type: ProfitType
});


export default class OrganizationDetailEditAccount extends Component {
  state = {
    formValue: {
      contact_first_name: '',
      contact_last_name: '',
      contact_email: '',
      contact_phone: '',
      contact_intl_phone: '',
      profit_type: ''
    },
    formOptions: {
      auto: 'none',
      fields: {
        contactHead: {
          type: 'static',
          label: 'Contact Person'
        },
        contact_first_name: {
          attrs: {
            placeholder: 'First Name'
          }
        },
        contact_last_name: {
          attrs: {
            placeholder: 'Last Name'
          }
        },
        contact_email: {
          attrs: {
            placeholder: 'Email'
          }
        },
        contact_phone: {
          attrs: {
            placeholder: 'Mobile Phone'
          }
        },
        contact_intl_phone: {
          attrs: {
            placeholder: 'International Phone'
          }
        },
        more: {
          type: 'static',
          label: 'Misc'
        },
        profit_type: {
            factory: t.form.Radio,
            label: 'Is your organization'
        }
      }
    }
  };

  updateContent = value => {
    let newState = this.state.formValue;
    for(const key in value) {
      newState[key] = value[key];
    }
    for(const key in newState) {
      if(key == 'contactHead' || key == 'more') {
        continue;
      }
      if(key == 'profit_type') {
        this.props.updateContent('is_non_profit', (newState['profit_type'] == 'nonprofit')? true : false);
        continue;
      }
      this.props.updateContent(key, newState[key]);
    }
    this.setState({ formValue: newState});
  };

  handleSave(e) {
    e.preventDefault();
    this.props.saveOrganization();
  }

  componentWillMount() {
    let profitType = 'forprofit';
    if(this.props.organization.is_non_profit) {
      profitType = 'nonprofit';
    }
    this.setState({ formValue: {
        contact_first_name: this.props.organization.contact_first_name || this.props.user.first_name || "",
        contact_last_name: this.props.organization.contact_last_name || this.props.user.last_name || "",
        contact_email: this.props.organization.contact_email || this.props.user.email || "",
        contact_phone: this.props.organization.contact_phone || this.props.user.phone_number || "",
        contact_intl_phone: this.props.organization.contact_intl_phone || "",
        profit_type: profitType
      }
    });
  }

  render() {
    return <form>
      <t.form.Form
               onChange={this.updateContent}
               value={this.state.formValue}
               ref="editAccountForm" type={AdminAccount} options={this.state.formOptions} />
      <div><button type="submit" onClick={this.handleSave.bind(this)}>Save</button></div>
    </form>;
  }

}



// WEBPACK FOOTER //
// ./src/components/OrganizationDetailEditAccount.jsx